import { useMemo } from 'react';
import useCategory from './useCategory';
import { IArticles, ICategory } from '../types';

export type ArticlesReturnData = {
  articles: IArticles | null;
  totalCount: number | null;
};

export default function useArticles(categoryId?: string): ArticlesReturnData {
  const category = useCategory(categoryId);

  const value = useMemo(() => {
    let _category: ICategory;

    if (category) {
      _category = category;
    } else {
      throw new Error('not sure what category to look up in useArticles....');
    }

    return {
      articles: _category.articles.results.map((a) => ({
        ...a,
        categoryId: _category.id,
      })),
      totalCount: _category.articles.pageInfo.totalCount,
    };
  }, [category]);
  return value;
}
